var map = {
	"./locale-provider/ar_EG.tsx": 1840,
	"./locale-provider/bg_BG.tsx": 1844,
	"./locale-provider/ca_ES.tsx": 1848,
	"./locale-provider/cs_CZ.tsx": 1852,
	"./locale-provider/de_DE.tsx": 1856,
	"./locale-provider/el_GR.tsx": 1860,
	"./locale-provider/en_GB.tsx": 1864,
	"./locale-provider/en_US.tsx": 1868,
	"./locale-provider/es_ES.tsx": 1869,
	"./locale-provider/et_EE.tsx": 1873,
	"./locale-provider/fa_IR.tsx": 1877,
	"./locale-provider/fi_FI.tsx": 1881,
	"./locale-provider/fr_BE.tsx": 1885,
	"./locale-provider/fr_FR.tsx": 1889,
	"./locale-provider/is_IS.tsx": 1893,
	"./locale-provider/it_IT.tsx": 1897,
	"./locale-provider/ja_JP.tsx": 1901,
	"./locale-provider/ko_KR.tsx": 1905,
	"./locale-provider/ku_IQ.tsx": 1909,
	"./locale-provider/nb_NO.tsx": 1913,
	"./locale-provider/nl_BE.tsx": 1917,
	"./locale-provider/nl_NL.tsx": 1921,
	"./locale-provider/pl_PL.tsx": 1925,
	"./locale-provider/pt_BR.tsx": 1929,
	"./locale-provider/pt_PT.tsx": 1933,
	"./locale-provider/ru_RU.tsx": 1937,
	"./locale-provider/sk_SK.tsx": 1941,
	"./locale-provider/sl_SI.tsx": 1945,
	"./locale-provider/sr_RS.tsx": 1948,
	"./locale-provider/sv_SE.tsx": 1952,
	"./locale-provider/th_TH.tsx": 1956,
	"./locale-provider/tr_TR.tsx": 1960,
	"./locale-provider/uk_UA.tsx": 1964,
	"./locale-provider/vi_VN.tsx": 1968,
	"./locale-provider/zh_CN.tsx": 1972,
	"./locale-provider/zh_TW.tsx": 1975
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1839;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 1839
// module chunks = 0